import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideAppInitializer, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { initialize, localStorageAdapter } from '@softion/tools';
import moment from 'moment';

import { routes } from './app.routes';
import { applySavedColorScheme } from './shared/utils/color-scheme';
import { authInterceptor } from './shared/interceptors/auth.interceptor';

moment.locale('es');
document.documentElement.setAttribute('data-theme', 'softion');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAppInitializer(() => applySavedColorScheme()),
    provideAppInitializer(() =>
      initialize({
        secretCrypto: 'sof-mgmt-v1',
        ls: {
          encryptKey:     false,
          encryptValue:   false,
          storageAdapter: localStorageAdapter,
        },
      }).then(() => void 0)
    ),
  ],
};
